import StudentWorkSection from './StudentWorkSection';

export default StudentWorkSection;
